<template>
  <v-app>
    <v-main class="suspended-page">
      <v-container class="fill-height" fluid>
        <v-row justify="center" align="center">
          <v-col cols="12" sm="8" md="6" lg="5">
            <v-card class="suspended-card tw-text-center" elevation="4">
              <div class="suspended-card__icon">
                <v-icon size="56" color="#e65100">
                  {{ isLabExpired ? "mdi-calendar-remove" : "mdi-lock" }}
                </v-icon>
              </div>

              <v-card-title class="tw-justify-center tw-text-xl tw-font-bold tw-block">
                {{
                  isLabExpired
                    ? "หมดอายุการใช้งาน AP Lab"
                    : "บริษัทนี้ถูกระงับการใช้งาน"
                }}
              </v-card-title>

              <v-card-text>
                <p v-if="isLabExpired" class="tw-text-base tw-text-gray-700 tw-mb-6">
                  ระยะเวลาใช้งาน AP Lab ของบริษัทนี้สิ้นสุดแล้ว<span v-if="labExpireDateText">
                    เมื่อวันที่ {{ labExpireDateText }}</span
                  >
                  จึงไม่สามารถเข้าใช้งานได้
                </p>
                <p v-else class="tw-text-base tw-text-gray-700 tw-mb-6">
                  ขณะนี้บริษัทของคุณถูกระงับการใช้งานชั่วคราว จึงไม่สามารถเข้าใช้งานได้
                </p>

                <p class="tw-mb-2 tw-text-sm tw-text-gray-600">
                  {{
                    isLabExpired
                      ? "หากต้องการใช้งานต่อ กรุณาติดต่อทีมงานเพื่อต่ออายุการใช้งาน"
                      : "กรุณาติดต่อฝ่ายบริการลูกค้าเพื่อเปิดใช้งานอีกครั้ง"
                  }}
                </p>
                <a href="tel:0661105989" class="suspended-card__phone">
                  <v-icon small color="#c9242b" class="tw-mr-1">mdi-phone</v-icon>
                  066-110-5989
                </a>
              </v-card-text>

              <v-card-actions class="tw-justify-center tw-pb-8 tw-pt-2">
                <v-btn
                  color="primary"
                  x-large
                  elevation="0"
                  class="suspended-card__btn tw-font-bold tw-px-8"
                  @click="goToCompanyList"
                >
                  <v-icon left>mdi-office-building-outline</v-icon>
                  กลับหน้าเลือกบริษัท
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import { mapState } from "vuex";
import { formatLabExpireDate, isLabLicenseExpired } from "@/libs/labLicense";

export default {
  name: "CompanySuspended",
  computed: {
    ...mapState({
      selectedCompany: (state) => state.companies.selectedCompany,
      selectedCompanyProductList: (state) =>
        state.companies.selectedCompanyProductList,
    }),
    companyId() {
      return this.$route.params.companyId;
    },
    // This page serves both block reasons. Suspension wins when both apply —
    // it is the deliberate staff action, so it is the one to explain.
    isLabExpired() {
      if (this.selectedCompany?.isSuspended === true) return false;
      return isLabLicenseExpired(this.selectedCompanyProductList);
    },
    labExpireDateText() {
      return formatLabExpireDate(
        this.selectedCompanyProductList?.isLabExpireDate
      );
    },
  },
  async created() {
    const companyId = this.companyId;
    try {
      // Re-verify against Firestore. If the company was unsuspended, a refresh
      // here should drop the user straight back into the workspace instead of
      // trapping them on this page. The dispatch also warms selectedCompany so
      // the reason shows when still blocked.
      const blocked = await this.$store.dispatch(
        "companies/isCompanyAccessBlocked",
        { companyId }
      );
      if (!blocked) {
        this.$router
          .replace({ name: "Company.Dashboard", params: { companyId } })
          .catch(() => {});
      }
    } catch (err) {
      // Couldn't verify — keep the user here (never auto-admit on error), but
      // make sure the reason isn't blank on a direct load.
      if (this.selectedCompany?.companyId !== companyId) {
        this.$store.dispatch("companies/setCompany", { companyId });
      }
    }
  },
  methods: {
    goToCompanyList() {
      this.$router.push("/companies-list").catch(() => {});
    },
  },
};
</script>

<style scoped lang="scss">
.suspended-page {
  background: #f5f6f8;
}

.suspended-card {
  border-radius: 16px;
  padding: 28px 24px 8px;

  &__icon {
    margin-bottom: 8px;
  }

  &__phone {
    display: inline-flex;
    align-items: center;
    margin-top: 10px;
    padding: 6px 16px;
    border: 1px solid #c9242b;
    border-radius: 999px;
    color: #c9242b;
    font-weight: 700;
    text-decoration: none;
    transition: transform 0.15s ease;

    &:hover {
      transform: translateY(-1px);
    }
  }

  &__btn {
    border-radius: 12px;
    letter-spacing: normal;
    box-shadow: 0 6px 16px rgba(110, 195, 155, 0.4);
    transition: transform 0.15s ease, box-shadow 0.15s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 10px 22px rgba(110, 195, 155, 0.5);
    }
  }
}
</style>
